import { render } from "./watermark-preview.vue?vue&type=template&id=aa9d9eac&scoped=true&ts=true"
import script from "./watermark-preview.vue?vue&type=script&lang=ts"
export * from "./watermark-preview.vue?vue&type=script&lang=ts"

import "./watermark-preview.vue?vue&type=style&index=0&id=aa9d9eac&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9d9eac"]])

export default __exports__